var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirbinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M7.0001 10.6601C6.21342 9.67048 5.75064 8.80296 5.59636 8.06076C5.44207 7.45767 5.50379 6.97836 5.76607 6.62273C6.0437 6.20521 6.46019 6.00421 7.0001 6.00421C7.54002 6.00421 7.95659 6.20521 8.23422 6.62273C8.49651 6.97836 8.55822 7.45767 8.40394 8.06076C8.23422 8.81847 7.77145 9.68436 7.0001 10.6601ZM11.3072 12.9485C9.99591 13.5207 8.69854 12.6083 7.58785 11.3713C9.42514 9.06585 9.76448 7.27219 8.97625 6.11093C8.51348 5.44604 7.85013 5.12127 7.0001 5.12127C5.28779 5.12127 4.34527 6.57481 4.71556 8.26176C4.93147 9.1741 5.50224 10.2117 6.41236 11.3713C5.72973 12.1296 4.8341 12.9898 3.75907 13.0877C2.20104 13.3197 0.980825 11.8043 1.53617 10.241L5.48682 2.04264C5.82402 1.42631 6.24016 0.89839 6.99856 0.89839C7.55391 0.89839 7.98591 1.22311 8.17096 1.48597L12.461 10.241C12.8813 11.2989 12.3483 12.4979 11.3072 12.9485ZM13.2971 9.93173L9.62417 2.27458C8.92997 0.852002 8.43634 0 7.0001 0C5.58093 0 4.97776 0.989617 4.3607 2.27458L0.703152 9.93173C-0.0835779 12.0981 1.53617 14 3.49687 14C3.6203 14 3.74278 13.9846 3.86707 13.9846C4.88519 13.8609 5.9357 13.2114 7.0001 12.0502C8.06451 13.2099 9.11511 13.8609 10.1332 13.9846C10.2575 13.9846 10.38 14 10.5034 14C12.4641 14.0015 14.0839 12.0981 13.2971 9.93173Z",
    fill: "#A6A9B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirbinIcon);
export default __webpack_public_path__ + "static/media/AIRBIN_ICON.baa4e6d5936865a864a5c2801ce27384.svg";
export { ForwardRef as ReactComponent };